import { useEffect, useState } from 'react'

import { useGlobalContext } from '../../../../../context/ContextGlobal'
import { getDocument, updateDocument } from '../../../../../firebase/firestore'
import { uploadFile } from '../../../../../firebase/storage'

export const useInfoEnterprise = () => {
  const { user, setUser, formContext, setFormContext } = useGlobalContext()

  const [userInfo, setUserInfo] = useState(null)
  const [navbarColor, setNavbarColor] = useState('#210057')

  // Busca dados do usuário no Firestore
  const getUserData = async () => {
    if (!user?.client?.id) return
    const currentUser = await getDocument('clientes', user.client.id)
    setUserInfo(currentUser)

    // Atualiza o estado da cor com o valor vindo do banco
    if (currentUser?.colornavbar) {
      setNavbarColor(currentUser.colornavbar)
    }
  }

  // Salva manualmente a cor no Firestore
  const handleSaveColor = async () => {
    if (!user?.client?.id) return
    await updateDocument('clientes', user.client.id, { colornavbar: navbarColor })

    // Atualiza localmente após salvar
    setUserInfo((prev) => ({
      ...prev,
      colornavbar: navbarColor,
    }))

    setUser((prev) => ({
      ...prev,
      colornavbar: navbarColor,
    }))
  }

  const handleUploadLogo = async () => {
    if (!formContext.logoUrl || !user?.client?.id) return

    const file = formContext.logoUrl // arquivo original para upload
    const img = new Image()
    img.src = URL.createObjectURL(file)

    img.onload = async () => {
      if (img.width !== 500 || img.height !== 500) {
        alert('Imagem deve ter exatamente 500x500 pixels.')
        return
      }

      try {
        // Define o caminho do arquivo no Firebase Storage
        const storagePath = `users/${user.client.id}/logo_marca.png`

        // Faz o upload da nova imagem. A imagem anterior será substituída automaticamente.
        const url = await uploadFile(file, storagePath)

        // Salva a URL da nova imagem no Firestore
        await updateDocument('clientes', user.client.id, { logoUrl: url })

        // Atualiza o estado global e local com a URL da nova logo
        setFormContext((prev) => ({ ...prev, logoUrl: url })) // Guarda a URL
        setUser((prev) => ({
          ...prev,
          client: {
            ...prev.client,
            logoUrl: url,
          },
        }))

        // Limpar o arquivo logoFile do formContext, pois só precisamos da URL
        setFormContext((prev) => ({ ...prev, logoFile: null }))
      } catch (error) {
        console.error('Erro ao fazer upload da imagem:', error)
      }
    }
  }

  useEffect(() => {
    getUserData()
    const validateImageDimensions = () => {
      if (!formContext.logoUrl) return

      const img = new Image()
      img.src = formContext.logoUrl

      img.onload = () => {
        const { width, height } = img
        if (width > 500 || height > 500) {
          alert('A imagem deve ter no máximo 500x500 pixels.')
          setFormContext((prev) => ({ ...prev, logoUrl: null, logoFile: null }))
        }
      }
    }

    validateImageDimensions()
  }, [formContext.logoUrl])

  return {
    user,
    userInfo,
    navbarColor,
    formContext,
    setFormContext,
    setNavbarColor,
    handleSaveColor,
    handleUploadLogo,
  }
}
